module.exports = __webpack_public_path__ + "static/8-e3508830c0d25bc49a653c0554e09ea0.jpg";